import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
//@ts-ignore: Missing types in `beautiful-react-hooks`
import useDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
import { useEffect, useState } from 'react';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { Input } from '@/components/core/Input';
import { useTranslation } from '@/hooks/useTranslation';

interface ToolbarProps {
    textFilter?: string;
    onTextFilterChange: (newValue: string) => void;
    onNewContentClick: () => void;
    deleteEnabled: boolean;
    onDeleteClick: () => void;
    onPublishClick: () => void;
    entriesApproved: boolean;
    canPublish: boolean;
}

const Toolbar = ({
    textFilter,
    onTextFilterChange,
    onNewContentClick,
    deleteEnabled,
    onDeleteClick,
}: ToolbarProps ) => {

    const { t } = useTranslation();
    const [ internalTextFilter, setInternalTextFilter ] = useState<string | undefined>(textFilter);
    const debouncedOnTextFilterChange = useDebouncedCallback(onTextFilterChange);

    useEffect(() => {
        debouncedOnTextFilterChange(internalTextFilter);
    }, [internalTextFilter, debouncedOnTextFilterChange]);

    useEffect(() => {
        setInternalTextFilter(textFilter);
    }, [textFilter]);

    return (
        <div className="tw-flex tw-flex-col tw-w-full tw-mb-2">
            <Input
                className="tw-flex-none tw-w-full tw-mb-2"
                placeholder={t('ENHANCED_CONTENT.SEARCH_PLACEHOLDER')}
                title={t('ENHANCED_CONTENT.SEARCH_PLACEHOLDER')}
                value={internalTextFilter}
                onChange={(event) => setInternalTextFilter(event.target.value)}
            />

            <div className="tw-flex tw-w-full">
                <Button
                    variant="default"
                    onClick={onNewContentClick}
                    title={t('ENHANCED_CONTENT.NEW_CONTENT')}
                >
                    <span className="tw-flex tw-items-center tw-justify-center">
                        <Icon icon={PlusIcon} size="sm" variant="light" className='tw-mt-[-2px] tw-stroke-2' />
                        <span className="tw-ml-2 tw-truncate">{t('ENHANCED_CONTENT.NEW_CONTENT')}</span>
                    </span>
                </Button>

                <Button
                    className="tw-ml-1"
                    variant="destructive"
                    onClick={onDeleteClick}
                    title={t('ACTION.DELETE')}
                    disabled={!deleteEnabled}
                >
                    <span className="tw-flex tw-items-center tw-justify-center">
                        <Icon icon={TrashIcon} size="sm" variant="destructive" disabled={!deleteEnabled} className='tw-mt-[-2px]'/>
                        <span className="tw-ml-2 tw-truncate">{t('ACTION.DELETE')}</span>
                    </span>
                </Button>
                {/*Temporarily removed due to confusing terminology. Will fix soon <Tooltip
                    popupContent={t('ENHANCED_CONTENT.PUBLISH')}>
                    <Button
                        variant="outline"
                        className="tw-ml-auto"
                        onClick={onPublishClick}
                        disabled={!deleteEnabled}
                        title={t('ENHANCED_CONTENT.PUBLISH')}
                    >
                        <span className="tw-flex tw-flex-none tw-justify-center tw-items-center">
                            <Icon icon={faArrowUpFromBracket} size="sm" variant="secondary" disabled={!deleteEnabled} />
                            <span className="tw-ml-2 tw-truncate">{t('ENHANCED_CONTENT.PUBLISH')}</span>
                        </span>
                    </Button>
                </Tooltip> */}
            </div>

        </div>
    );
};

export { Toolbar };
